import { Component } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { Router } from '@angular/router';
import {
  heroHomeSolid,
  heroAcademicCapSolid,
  heroInboxStackSolid,
  heroBuildingOfficeSolid,
  heroBuildingLibrarySolid,
  heroBuildingOffice2Solid,
} from '@ng-icons/heroicons/solid';
import { CommonModule } from '@angular/common';
import { featherBox } from '@ng-icons/feather-icons';
import { heroSwatch } from '@ng-icons/heroicons/outline';

@Component({
  selector: 'app-sidebar',
  imports: [NgIcon, CommonModule],
  templateUrl: './sidebar.component.html',
  viewProviders: [
    provideIcons({
      heroHomeSolid,
      featherBox,
      heroAcademicCapSolid,
      heroInboxStackSolid,
      heroBuildingOfficeSolid,
      heroBuildingLibrarySolid,
      heroBuildingOffice2Solid,
      heroSwatch,
    }),
  ],
})
export class SidebarComponent {
  constructor(private router: Router) {}

  items = [
    { name: 'Home', route: '/admin', icon: 'heroHomeSolid' },
    { name: 'Paquetes', route: '/admin/package', icon: 'featherBox' },
    { name: 'Áreas', route: '/admin/area', icon: 'heroAcademicCapSolid' },
    {
      name: 'Profesiones',
      route: '/admin/profession',
      icon: 'heroBuildingLibrarySolid',
    },
    {
      name: 'Líneas de negocio',
      route: '/admin/business-line',
      icon: 'heroSwatch',
    },
    {
      name: 'Tipos de empleos',
      route: '/admin/job-type',
      icon: 'heroBuildingOfficeSolid',
    },
    {
      name: 'Títulos de empleos',
      route: '/admin/job-title',
      icon: 'heroInboxStackSolid',
    },
  ];

  isActive(path: string): boolean {
    return this.router.url === path;
  }

  navigate(path: string) {
    this.router.navigateByUrl(path);
  }
}
